import React from 'react';
import Sidebar from '../components/Sidebar';
import PageHeader from '../components/PageHeader';
import DailyTasks from '../components/robots/DailyTasks';
import './Page.css';

const Robots: React.FC = () => {
  return (
    <div className="page-container">
      <div className="page-layout">
        <Sidebar />
        <main className="page-main">

          <div>
            <PageHeader title="Robots" subtitle="Services conducted at each business, by day" />
          </div>

          <div className="page-content">
            <DailyTasks />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Robots;
